<template>
  <v-btn
    class="p-1 mr-2"
    @click="getCount"
    dark
    small
    color="#FFCA28"
    :loading="loading"
  >
    <slot name="audience-button-title" :title="title"></slot>
  </v-btn>
  <!-- <button
    class="btn btn-sm btn-warning w-10 p-1 mr-2 text-center"
    @click="getCount"
  >
    <slot name="audience-button-title" :title="title"></slot>
    <div
      class="spinner-border text-light my-1 mx-3"
      style="width: 12px !important; height: 12px !important"
      v-if="loading"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </button> -->
</template>

<script>
import numeral from "numeral";
import Segments from "../../apis/Segments";

export default {
  name: "AudienceCountButton",
  props: {
    websiteId: {
      type: String,
      required: true,
    },
    query: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      title: "Count",
      loading: false,
    };
  },
  methods: {
    /**
     * @type {Function} type - obtain subscriptions count
     */
    getCount() {
      if (this.title === "Count") {
        this.title = "";
        this.loading = true;

        Segments.getAudCount(this.websiteId, this.query[0])
          .then((response) => {
            this.loading = false;
            this.title = this.formatNumber(response.data.data);
          })
          .catch(() => {
            this.title = "Count";
            this.loading = false;
          });
      } else {
        this.title = "Count";
      }
    },
    /**
     * /**
      * @type {Function} type - format number
      * @param {STRING || NUMBER} param
      * @return {STRING || NUMBER} formatted digit
     */
    formatNumber(number) {
      return Math.floor(Math.log10(Math.abs(number))) + 1 > 3
        ? numeral(number).format("0.0a")
        : number;
    },
  },
};
</script>
